module.exports = __webpack_public_path__ + "static/media/refer_icon.39f0be11.svg";